/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type Currency = ('AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD' | '%future added value');
export type UserProjectRoleEnumType = ('collaborator' | 'owner' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type project_viewer$ref: FragmentReference;
export type project_viewer = {|
  +latest_project: ?{|
    +id: string,
    +is_public: ?boolean,
    +name: string,
    +notes: ?string,
    +opaque_id: ?string,
    +tracks: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +id: string,
        +version: string,
        +node: ?{|
          +id: string,
          +internal_id: ?number,
          +price: ?number,
          +base_price: ?number,
          +title: ?string,
          +added_to_cart: ?boolean,
          +slug: ?string,
          +duration: ?number,
          +score: ?number,
          +boosted_score: ?number,
          +stems_available: ?boolean,
          +customizable: ?boolean,
          +matched_exclusions: ?$ReadOnlyArray<?number>,
          +tempos: ?$ReadOnlyArray<?{|
            +id: string,
            +name: ?string,
            +value: ?number,
          |}>,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
          +artist: ?{|
            +id: string,
            +name: ?string,
            +slug: ?string,
            +bio: ?string,
            +bandcamp: ?string,
            +facebook: ?string,
            +instagram: ?string,
            +itunes: ?string,
            +soundcloud: ?string,
            +spotify: ?string,
            +twitter: ?string,
            +wiki: ?string,
            +youtube: ?string,
            +homebase: ?string,
            +assets: ?$ReadOnlyArray<?{|
              +id: string,
              +version: ?string,
              +type: ?string,
              +file_format: ?string,
              +path: ?string,
              +metadata: ?any,
            |}>,
          |},
          +terms: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +is_highlighted: ?boolean,
                +name: ?string,
                +parent_id: ?string,
                +taxonomy: ?{|
                  +id: string,
                  +internal_id: ?number,
                  +name: ?string,
                |},
              |},
            |}>,
          |},
          +collections: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +description: ?string,
                +name: string,
                +slug: ?string,
                +category: ?{|
                  +id: string,
                  +name: ?string,
                |},
                +assets: ?$ReadOnlyArray<?{|
                  +id: string,
                  +version: ?string,
                  +type: ?string,
                  +file_format: ?string,
                  +path: ?string,
                  +metadata: ?any,
                |}>,
              |},
            |}>,
          |},
          +association_id: ?string,
          +selected_version: ?string,
        |},
      |}>,
    |},
    +owner: ?{|
      +id: string,
      +first_name: ?string,
      +last_name: ?string,
      +user_id: string,
    |},
    +users: ?$ReadOnlyArray<?{|
      +id: string,
      +first_name: ?string,
      +last_name: ?string,
      +user_id: string,
      +role: UserProjectRoleEnumType,
    |}>,
    +license_params: ?$ReadOnlyArray<?{|
      +spot_count: ?number,
      +term: ?number,
      +medium: number,
      +contextual_param: ?$ReadOnlyArray<?number>,
      +contextual_param_type: string,
    |}>,
  |},
  +projects: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +is_public: ?boolean,
        +name: string,
        +notes: ?string,
        +tracks: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +id: string,
          |}>,
        |},
        +owner: ?{|
          +id: string,
          +first_name: ?string,
          +last_name: ?string,
          +user_id: string,
        |},
        +users: ?$ReadOnlyArray<?{|
          +id: string,
          +first_name: ?string,
          +last_name: ?string,
          +user_id: string,
          +role: UserProjectRoleEnumType,
        |}>,
        +license_params: ?$ReadOnlyArray<?{|
          +spot_count: ?number,
          +term: ?number,
          +medium: number,
          +contextual_param: ?$ReadOnlyArray<?number>,
          +contextual_param_type: string,
        |}>,
      |},
    |}>,
  |},
  +node?: ?{|
    +id?: string,
    +is_public?: ?boolean,
    +name?: string,
    +notes?: ?string,
    +opaque_id?: ?string,
    +tracks?: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +id: string,
        +version: string,
        +node: ?{|
          +id: string,
          +internal_id: ?number,
          +price: ?number,
          +base_price: ?number,
          +title: ?string,
          +added_to_cart: ?boolean,
          +slug: ?string,
          +duration: ?number,
          +score: ?number,
          +boosted_score: ?number,
          +stems_available: ?boolean,
          +customizable: ?boolean,
          +matched_exclusions: ?$ReadOnlyArray<?number>,
          +tempos: ?$ReadOnlyArray<?{|
            +id: string,
            +name: ?string,
            +value: ?number,
          |}>,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
          +artist: ?{|
            +id: string,
            +name: ?string,
            +slug: ?string,
            +bio: ?string,
            +bandcamp: ?string,
            +facebook: ?string,
            +instagram: ?string,
            +itunes: ?string,
            +soundcloud: ?string,
            +spotify: ?string,
            +twitter: ?string,
            +wiki: ?string,
            +youtube: ?string,
            +homebase: ?string,
            +assets: ?$ReadOnlyArray<?{|
              +id: string,
              +version: ?string,
              +type: ?string,
              +file_format: ?string,
              +path: ?string,
              +metadata: ?any,
            |}>,
          |},
          +terms: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +is_highlighted: ?boolean,
                +name: ?string,
                +parent_id: ?string,
                +taxonomy: ?{|
                  +id: string,
                  +internal_id: ?number,
                  +name: ?string,
                |},
              |},
            |}>,
          |},
          +collections: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +description: ?string,
                +name: string,
                +slug: ?string,
                +category: ?{|
                  +id: string,
                  +name: ?string,
                |},
                +assets: ?$ReadOnlyArray<?{|
                  +id: string,
                  +version: ?string,
                  +type: ?string,
                  +file_format: ?string,
                  +path: ?string,
                  +metadata: ?any,
                |}>,
              |},
            |}>,
          |},
          +association_id: ?string,
          +selected_version: ?string,
        |},
      |}>,
    |},
    +owner?: ?{|
      +id: string,
      +first_name: ?string,
      +last_name: ?string,
      +user_id: string,
    |},
    +users?: ?$ReadOnlyArray<?{|
      +id: string,
      +first_name: ?string,
      +last_name: ?string,
      +user_id: string,
      +role: UserProjectRoleEnumType,
    |}>,
    +license_params?: ?$ReadOnlyArray<?{|
      +spot_count: ?number,
      +term: ?number,
      +medium: number,
      +contextual_param: ?$ReadOnlyArray<?number>,
      +contextual_param_type: string,
    |}>,
  |},
  +selected_currency: ?Currency,
  +$refType: project_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "is_public",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "version",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "internal_id",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "assets",
  "storageKey": null,
  "args": null,
  "concreteType": "Asset",
  "plural": true,
  "selections": [
    v0,
    v4,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "first_name",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "last_name",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "user_id",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "owner",
  "storageKey": null,
  "args": null,
  "concreteType": "ProjectUser",
  "plural": false,
  "selections": [
    v0,
    v11,
    v12,
    v13
  ]
},
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "users",
  "storageKey": null,
  "args": null,
  "concreteType": "ProjectUser",
  "plural": true,
  "selections": [
    v0,
    v11,
    v12,
    v13,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "role",
      "args": null,
      "storageKey": null
    }
  ]
},
v16 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "license_params",
  "storageKey": null,
  "args": null,
  "concreteType": "LicenseUsageParams",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "spot_count",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "term",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "medium",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contextual_param",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contextual_param_type",
      "args": null,
      "storageKey": null
    }
  ]
},
v17 = [
  v0,
  v1,
  v2,
  v3,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "opaque_id",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": "tracks",
    "name": "__project_tracks_connection",
    "storageKey": null,
    "args": null,
    "concreteType": "ProjectTrackConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ProjectTrackEdge",
        "plural": true,
        "selections": [
          v0,
          v4,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "TrackSearchResult",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "stems_available",
                "args": null,
                "storageKey": null
              },
              v0,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "price",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "base_price",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "added_to_cart",
                "args": null,
                "storageKey": null
              },
              v5,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "duration",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "score",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "boosted_score",
                "args": null,
                "storageKey": null
              },
              v6,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "customizable",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "matched_exclusions",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tempos",
                "storageKey": null,
                "args": null,
                "concreteType": "Tempo",
                "plural": true,
                "selections": [
                  v0,
                  v2,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "value",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              v7,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "artist",
                "storageKey": null,
                "args": null,
                "concreteType": "Artist",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "itunes",
                    "args": null,
                    "storageKey": null
                  },
                  v0,
                  v5,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "bio",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "bandcamp",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "facebook",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "instagram",
                    "args": null,
                    "storageKey": null
                  },
                  v2,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "soundcloud",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "spotify",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "twitter",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "wiki",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "youtube",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "homebase",
                    "args": null,
                    "storageKey": null
                  },
                  v7
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "terms",
                "storageKey": "terms(first:100)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100,
                    "type": "Int"
                  }
                ],
                "concreteType": "TaxonomyTermConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TaxonomyTermEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TaxonomyTerm",
                        "plural": false,
                        "selections": [
                          v0,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "is_highlighted",
                            "args": null,
                            "storageKey": null
                          },
                          v2,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "parent_id",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "taxonomy",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Taxonomy",
                            "plural": false,
                            "selections": [
                              v0,
                              v6,
                              v2
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "collections",
                "storageKey": null,
                "args": null,
                "concreteType": "CollectionTrackConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CollectionTrackEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Collection",
                        "plural": false,
                        "selections": [
                          v0,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "description",
                            "args": null,
                            "storageKey": null
                          },
                          v2,
                          v5,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "category",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CollectionCategory",
                            "plural": false,
                            "selections": [
                              v0,
                              v2
                            ]
                          },
                          v7
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "association_id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "selected_version",
                "args": null,
                "storageKey": null
              },
              v8
            ]
          },
          v9
        ]
      },
      v10
    ]
  },
  v14,
  v15,
  v16
];
return {
  "kind": "Fragment",
  "name": "project_viewer",
  "type": "Viewer",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "projects"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "id",
      "type": "ID!"
    },
    {
      "kind": "RootArgument",
      "name": "isDefaultRoute",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "latest_project",
      "storageKey": null,
      "args": null,
      "concreteType": "Project",
      "plural": false,
      "selections": v17
    },
    {
      "kind": "LinkedField",
      "alias": "projects",
      "name": "__list_projects_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ProjectConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ProjectEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Project",
              "plural": false,
              "selections": [
                v0,
                v1,
                v2,
                v3,
                {
                  "kind": "LinkedField",
                  "alias": "tracks",
                  "name": "__project_tracks_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ProjectTrackConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ProjectTrackEdge",
                      "plural": true,
                      "selections": [
                        v0,
                        v9,
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "TrackSearchResult",
                          "plural": false,
                          "selections": [
                            v8
                          ]
                        }
                      ]
                    },
                    v10
                  ]
                },
                v14,
                v15,
                v16,
                v8
              ]
            },
            v9
          ]
        },
        v10
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "selected_currency",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": false,
      "condition": "isDefaultRoute",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "id",
              "variableName": "id",
              "type": "ID!"
            }
          ],
          "concreteType": null,
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "type": "Project",
              "selections": v17
            }
          ]
        }
      ]
    }
  ]
};
})();
(node/*: any*/).hash = 'b9664a1a6532247f0b8b56db1d25f777';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/project_viewer.graphql.js